import { ValidationRulePatternType } from 'graphql-ts-types';

import { GLOBAL_REGEX_FLAG, INVALID_CHARS_ERROR_MSG } from '../constants';
import type { ValidatePatternOptions } from '../types';
import { getRegexPattern } from './regex-helpers';

const getInvalidCharactersList = (value: string, regex: RegExp): string => {
  const matches = value?.match(regex) || [];

  if (!!matches.length) {
    let invalidCharactersList = value;

    for (const match of matches) {
      invalidCharactersList = invalidCharactersList.replace(match, '');
    }

    return [...new Set(invalidCharactersList.split(''))].join('');
  }

  return '';
};

export const getPatternErrorMessage = ({ rule, inputValue, translate }: ValidatePatternOptions) => {
  if (rule.type === ValidationRulePatternType.Pattern) {
    const invalidCharactersList = getInvalidCharactersList(
      inputValue,
      getRegexPattern(rule.value.replace(/[/^$]/g, ''), GLOBAL_REGEX_FLAG)
    );

    if (invalidCharactersList.length === 0) {
      return rule.errorMessage;
    }

    const containsOnlyNumber = /^\d+$/.exec(invalidCharactersList);
    const containsOnlyNonNumber = /^\D+$/.exec(invalidCharactersList);

    let errorMessage = 'h24_validation_error_form_invalid_special_characters_and_numbers';

    if (containsOnlyNonNumber) {
      errorMessage = INVALID_CHARS_ERROR_MSG;
    } else if (containsOnlyNumber) {
      errorMessage = 'h24_validation_error_form_invalid_numbers';
    }

    return `${rule.errorMessage} ${translate(errorMessage)}`;
  }

  return rule.errorMessage;
};
